/* eslint-disable no-await-in-loop */
/* eslint-disable prefer-const */
import sleep from "@/common/utils/sleep";
import { apiUpload } from "@/common/services";

import { getHash } from "./fileHasher";

class UnsupportedUploadMethod extends Error {}

class UploadError extends Error {}

interface fetchUrlParams {
  readonly url: string;
}

interface fetchUrlReturn {
  downloadUrl: string;
  timelineUrl?: string;
  kind: string;
  id: string;
}

interface checkUploadStatusParams {
  readonly id: string;
}

interface checkUploadStatusReturn {
  downloadUrl: string;
  timelineUrl?: string;
  kind: string;
}

export const uploadFile = async (
  file: File,
  progress: (loaded: number, total: number) => void | undefined,
  ticketInfo?: {
    url: string;
    method: string;
    id: string;
  }
) => {
  let md5 = null;

  try {
    md5 = await getHash(file);
  } catch (e) {
    // eslint-disable-next-line
    console.log("Hashing is failed", e);
  }

  // Let the devs bypass caching and force file upload.
  if (file.name.indexOf("_nohash.") > 0) {
    md5 = null;
  }

  const ticket = ticketInfo || await apiUpload.getUploadTicket({ md5 });

  if (ticket.url) {
    if (ticket.method === "PUT") {
      await putFile(file, ticket.url, progress);
    } else {
      throw new UnsupportedUploadMethod(
        `Upload method ${ticket.method} is not implemented.`
      );
    }
  } else {
    progress && progress(file.size, file.size);
  }

  let status = null;
  let timeLineUrl = "";

  while (status !== "ready") {
    const res = await apiUpload.getTicketStatus({ id: ticket.id });
    timeLineUrl = res?.timelineUrl || "";
    status = res.status;

    if (status === "failed") {
      throw new Error("ticket failed");
    }
    // eslint-disable-next-line
    await sleep(1000);
  }

  return { id: ticket.id, timeLineUrl: timeLineUrl };
};

const putFile = async (
  file: File,
  url: string,
  progress: (loaded: number, total: number) => void | undefined
): Promise<void> => {
  const callback = (event: ProgressEvent) => {
    progress && progress(event.loaded, event.total);
  };

  try {
    await apiUpload.putFile({
      url,
      file,
      callback
    });
  } catch (e) {
    throw new UploadError("Error uploading a file.");
  }
};

export const fetchUrl = async ({
  url
}: fetchUrlParams): Promise<fetchUrlReturn> => {
  let {
    id,
    downloadUrl,
    status,
    kind,
    timelineUrl
  } = await apiUpload.getUploadTicket({ url });

  if (status === "processing" || status === "waiting") {
    ({ downloadUrl, kind, timelineUrl } = await checkUploadStatus({ id }));
  }

  return {
    downloadUrl: downloadUrl as string,
    timelineUrl,
    kind,
    id
  };
};

const checkUploadStatus = async ({
  id
}: checkUploadStatusParams): Promise<checkUploadStatusReturn> => {
  let downloadUrl,
    timelineUrl,
    kind,
    status = null,
    error = null;

  do {
    ({
      downloadUrl,
      timelineUrl,
      kind,
      error = null,
      status = null
    } = await apiUpload.getTicketStatus({ id }));

    if (status === "failed" && error !== null) {
      throw new UploadError(error);
    }

    // eslint-disable-next-line no-magic-numbers
    await sleep(1000);
  } while (status !== "ready");

  return {
    downloadUrl: downloadUrl as string,
    timelineUrl,
    kind
  };
};
